import NewspaperDesktop from '../../pages/newspaper/NewspaperDesktop'
import NewspaperMobile from '../../pages/newspaper/NewspaperMobile'
import multiguard from 'vue-router-multiguard'
import authGuard from '../../guards/auth.guard'

const newspaper =
  {
    path: 'create',
    name: 'Newspaper',
    component: window.innerWidth >= 1025 ? NewspaperDesktop : NewspaperMobile,
    meta: {
      title: 'Page Title'
    },
    beforeEnter: multiguard([authGuard])

  }

export default newspaper
